import React from 'react';

import { ITransactionItem, ConfigTable } from '..';
import {
  Wrapper,
  BottomSection,
  Text,
  PublishButton,
} from './UnpublishedData.styles';
import { ITaxonomyItem, IRuleItem, SpendTypeEnum, ISpendDataInfo } from '..';
import { SPEND_LABELS } from '../ClassificationTable/utils';
import { PERMISSIONS } from 'utils/constants';

const LABELS = {
  requireClassification:
    'There are still transactions that require classification before the data can be published.',
  classified:
    'All transactions have been classified. Click Publish to make the data available to all users.',
};

interface IProps {
  taxonomyOptions: ITaxonomyItem[];
  spendType: SpendTypeEnum;
  spendDataInfo: ISpendDataInfo | null;
  updateTransactions(data: ITransactionItem[]): Promise<any>;
  updateRules(data: IRuleItem[]): Promise<any>;
  fetchSpendDataInfo(): Promise<any>;
  publish(): void;
  permissions: string[];
}

export const UnpublishedData: React.FC<IProps> = ({
  spendType,
  spendDataInfo,
  taxonomyOptions,
  updateTransactions,
  permissions,
  updateRules,
  fetchSpendDataInfo,
  publish,
}) => {
  const isDisabled =
    !spendDataInfo || spendDataInfo.count > 0 || !spendDataInfo.lastUpdatedDate;
  const text = isDisabled ? LABELS.requireClassification : LABELS.classified;
  const hasSalaryPermission = permissions.includes(PERMISSIONS.SALARY_READ);
  const canPublishData = permissions.includes(
    PERMISSIONS.UNPUBLISHED_DATA_WRITE
  );
  const hasWritePermission = permissions.includes(
    PERMISSIONS.SETTINGS_CLASSIFICATION_WRITE
  );

  return (
    <Wrapper>
      <ConfigTable
        spendType={spendType}
        taxonomyOptions={taxonomyOptions}
        updateTransactions={updateTransactions}
        updateRules={updateRules}
        fetchSpendDataInfo={fetchSpendDataInfo}
        lastUpdatedDate={spendDataInfo && spendDataInfo.lastUpdatedDate}
        hasSalaryPermission={hasSalaryPermission}
        hasWritePermission={hasWritePermission}
      />
      {canPublishData && (
        <BottomSection>
          <Text>{text}</Text>
          <PublishButton
            disabled={isDisabled}
            iconName="baseline_arrow_forward"
            onClick={publish}
          >
            Publish {SPEND_LABELS[spendType]} spend
          </PublishButton>
        </BottomSection>
      )}
    </Wrapper>
  );
};
